import {Option, option} from "ts-option";
import {store} from "../../navigation/ReduxProvider";
import DictionaryItem from "../../model/dictionary/DictionaryItem";

/**
 * Gets lead type.
 * @param {string} leadTypeId Lead type identifier to get.
 * @returns {Option<DictionaryItem>} LeadType.
 */
export function getLeadType(leadTypeId: string): Option<DictionaryItem> {
	const leadTypes = store.getState().leadType.leadTypes.getOrElse([]);
	const leadType = leadTypes.filter((jt) => jt.id == leadTypeId);
	return option(leadType[0]);
}